<template>
  <q-banner
    v-if="hasError"
    class="bg-negative text-white q-ma-md"
    rounded>
    {{ errorMessage }}
    <template #action>
      <q-btn
        flat
        :label="$t('core.AiDocumentProcessor.actions.retry')"
        @click="retryLoad" />
    </template>
  </q-banner>
  <AiDocumentProcessor v-else />
</template>

<script setup lang="ts">
import AiDocumentProcessor from 'src/CrudManager/Core/composites/AiDocumentProcessor/AiDocumentProcessor.vue'
import { showErrorNotification } from 'src/CrudManager/Core/Utils/ToastNotification'
import { onErrorCaptured, ref } from 'vue'

/**
 * AI Document Processor page — thin wrapper providing an error boundary
 * around the composite.
 */
const hasError = ref(false)
const errorMessage = ref('')

const retryLoad = (): void => {
  hasError.value = false
  errorMessage.value = ''
}

onErrorCaptured((error) => {
  hasError.value = true
  errorMessage.value = error.message || String(error)
  showErrorNotification(errorMessage.value)
  return false
})

defineOptions({
  meta: {
    title: 'Documents IA',
    description: 'Téléversement et traitement de documents par IA',
  },
})
</script>
